<template>
  <div class="form__group -has-label recap-div" :class="{ error: error }">
    <div v-if="!isLoaded">Loading...</div>
    <div ref="hcaptcha" class="h-captcha" :data-sitekey="sitekey"></div>
    <span v-if="error" class="message">Please check box</span>
  </div>
</template>

<script>
import { defineComponent } from 'vue'

// tracked outside of component to avoid re-rendering;
let hcaptchaPosition = undefined

/**
 * hcaptcha replacement for gcaptcha
 * @see https://docs.hcaptcha.com/switch/
 */
export default defineComponent({
  name: 'HCaptcha',
  props: {
    // allow parent forms to handle on submit and pass in true
    error: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['verify', 'expired', 'error'],
  data() {
    return {
      sitekey: 'e41db913-f2f5-401c-8c91-683845cbc222',
      isLoaded: false,
    }
  },
  // lifecycle methods
  mounted() {
    // alias component method for captcha onload callback
    window.captchaApiLoaded = this.captchaApiLoaded

    // load script
    let hcaptchaScript = document.createElement('script')
    hcaptchaScript.setAttribute(
      'src',
      'https://js.hcaptcha.com/1/api.js?hl=en&onload=captchaApiLoaded&render=explicit',
    )
    hcaptchaScript.setAttribute('async', true)
    hcaptchaScript.setAttribute('defer', true)

    document.head.appendChild(hcaptchaScript)

    // specific to iOS
    this.mobileScrollFix()
  },

  // instance methods
  methods: {
    captchaApiLoaded() {
      this.isLoaded = true

      // render
      window.hcaptcha.render(this.$refs.hcaptcha, {
        sitekey: this.sitekey,
        callback: (response) => {
          this.onCaptchaSuccess(response)
        },
        'expired-callback': this.emitExpired,
        'error-callback': this.emitError,
      })
    },

    // let parent components know value
    onCaptchaSuccess(response) {
      this.$emit('verify', response)

      if (this.isIOS && hcaptchaPosition !== undefined) {
        window.scrollTo(0, hcaptchaPosition)
      }
    },

    emitExpired() {
      this.$emit('expired')
    },

    emitError() {
      this.$emit('error')
    },

    isIOS() {
      return /iPhone|iPad|iPod/i.test(navigator.userAgent)
    },

    // fix iOS captcha scrolling down the page
    // https://github.com/google/recaptcha/issues/130#issuecomment-362308382
    mobileScrollFix() {
      const HEADER_HEIGHT = 10 // Height of header/menu fixed if exists

      const isScrolledIntoView = function (elem) {
        const elemRect = elem.getBoundingClientRect()
        const isVisible = elemRect.top - HEADER_HEIGHT >= 0 && elemRect.bottom <= window.innerHeight
        return isVisible
      }

      // manual polyfill, could probably be deleted since we have core-js
      // but not tested without soooo....
      if (!String.prototype.startsWith) {
        String.prototype.startsWith = function (search, pos) {
          return this.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search
        }
      }

      // scroll listener
      if (this.isIOS()) {
        const captchaElement = document.querySelector('.h-captcha')
        window.addEventListener(
          'scroll',
          function () {
            if (isScrolledIntoView(captchaElement)) {
              hcaptchaPosition = document.documentElement.scrollTop || document.body.scrollTop
            }
          },
          false,
        )
      }
      // end scroll listener
    },
  },
})
</script>
